var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyCandidateNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 0.25V17.75H27.75V0.25H25.25ZM20.25 17.75H22.75V0.25H20.25V17.75ZM16.5 0.25H1.5C0.8125 0.25 0.25 0.8125 0.25 1.5V16.5C0.25 17.1875 0.8125 17.75 1.5 17.75H16.5C17.1875 17.75 17.75 17.1875 17.75 16.5V1.5C17.75 0.8125 17.1875 0.25 16.5 0.25ZM9 3.6875C10.55 3.6875 11.8125 4.95 11.8125 6.5C11.8125 8.05 10.55 9.3125 9 9.3125C7.45 9.3125 6.1875 8.05 6.1875 6.5C6.1875 4.95 7.45 3.6875 9 3.6875ZM14.625 15.25H3.375V14.3125C3.375 12.4375 7.125 11.5 9 11.5C10.875 11.5 14.625 12.4375 14.625 14.3125V15.25Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyCandidateNew);
export default __webpack_public_path__ + "static/media/company-candidate-new.a6a63d3b7923398b97c99b97fc838c11.svg";
export { ForwardRef as ReactComponent };